import { render, staticRenderFns } from "./workOrrestEdit.vue?vue&type=template&id=369d70e3&scoped=true&"
import script from "./workOrrestEdit.vue?vue&type=script&lang=js&"
export * from "./workOrrestEdit.vue?vue&type=script&lang=js&"
import style0 from "./workOrrestEdit.vue?vue&type=style&index=0&id=369d70e3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369d70e3",
  null
  
)

export default component.exports